module.exports = __webpack_public_path__ + "static/img/16.810c52e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ment/333/22/16.png
// module id = M7z6
// module chunks = 0